export enum ShortcutAction {
  OpenAiAgents = "openAiAgents",
  OpenDealsList = "openDealsList",
  OpenInbox = "openInbox",
  ToggleCommandBar = "toggleCommandBar",
  ToggleHelp = "toggleHelp",
  ToggleSidebar = "toggleSidebar",
  PreviousSmartview = "previousSmartview",
  NextSmartview = "nextSmartview",
  OpenSmartviews = "openSmartviews",
  DealSearch = "dealSearch",
  PreviousDeal = "previousDeal",
  NextDeal = "nextDeal",
  StartCall = "startCall",
  ComposeEmail = "composeEmail",
  ComposeSms = "composeSms",
  CreateTask = "createTask",
  NextDealStage = "nextDealStage",
  PreviousDealStage = "previousDealStage",
  MarkDealDead = "markDealDead",
  MarkDealDeadBackspace = "markDealDeadBackspace",
  GoToDocuments = "goToDocuments",
  GoToProgress = "goToProgress",
  GoToActivity = "goToActivity",
  GoToLinks = "goToLinks",
  GoToTracking = "goToTracking",
  OpenActivityNotes = "openActivityNotes",
  CopyDealName = "copyDealName",
  CopyDealUrl = "copyDealUrl",
  CopyDealUuid = "copyDealUuid",
  OpenEditStips = "openEditStips",
}

export enum CallDispositionShortcut {
  BadNumber = "badNumber",
  DiscoveryCall = "discoveryCall",
  MadeContact = "madeContact",
  NoAnswer = "noAnswer",
  OfferPresentation = "offerPresentation",
  SpokeWithDm = "spokeWithDm",
  Voicemail = "voicemail",
}

export enum TextEditorShortcut {
  Bold = "bold",
  Italic = "italic",
  Underline = "underline",
  Strike = "strike",
  Link = "link",
  OrderedList = "orderedList",
  UnorderedList = "unorderedList",
  ChooseTemplate = "chooseTemplate",
}

export enum ShortcutContext {
  Global = "global",
  DealsList = "dealsList",
  ActiveDeal = "activeDeal",
  EmailSms = "emailSms",
  CallDisposition = "callDisposition",
}

export enum ModifierKeys {
  Alt = "altKey",
  Ctrl = "ctrlKey",
  Meta = "metaKey",
  Shift = "shiftKey",
}
